import throttle from 'lodash.throttle';
import eventListeners from './event-listeners';

const LONG_PRESS_DURATION = 750;

const customTouchEventsListener = (element) => {
  let longPressTimer;
  let cachedClientX;
  let cachedClientY;
  let cachedTarget;

  function handleTouchStart(event) {
    longPressTimer = setTimeout(() => {
      element.dispatchEvent(
        new CustomEvent('ws:longpress', {
          bubbles: true,
          detail: {
            clientX: event.touches[0].clientX,
            clientY: event.touches[0].clientY,
          },
        })
      );
    }, LONG_PRESS_DURATION);

    cachedClientX = event.changedTouches[0].clientX;
    cachedClientY = event.changedTouches[0].clientY;
    cachedTarget = event.target;
  }

  const handleTouchMove = throttle(() => {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
    }
  }, LONG_PRESS_DURATION / 2);

  function handleTouchEnd(event) {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
    }

    const { clientX, clientY } = event.changedTouches[0];

    if (Math.abs(cachedClientX - clientX) <= 10 && Math.abs(cachedClientY - clientY) <= 10) {
      element.dispatchEvent(
        new CustomEvent('ws:tap', {
          bubbles: true,
          detail: {
            target: cachedTarget,
          },
        })
      );
    }

    cachedClientX = null;
    cachedClientY = null;
    cachedTarget = null;
  }

  eventListeners.add(element, 'touchstart', handleTouchStart);
  eventListeners.add(element, 'touchmove', handleTouchMove);
  eventListeners.add(element, 'touchend', handleTouchEnd);
};

export default customTouchEventsListener;
